<script lang="ts">
  import { appState } from "../lib/Store";
  import { fade } from "svelte/transition";
import BackEnd from "../lib/BackEnd";
  
  const submit = (ev) => {
    const formData = new FormData(ev.target);
    const data = {};
    for (let field of formData) {
      const [key, value] = field;
      data[key] = value;
    }

    BackEnd.checkKey(data).then(ok=>{
        console.log(ok)
        appState.set({ user: ok });
       }).catch(err=> console.error(err));
  };
</script>

<main in:fade>
  <center>
    <div class="Login">
      <h4>Your Key Please:</h4>
      <form on:submit|preventDefault={submit}>
        <input type="text" name="key" id="key" />
        <button type="submit">Login</button>
      </form>
    </div>
  </center>
</main>

<style>
  .Login {
    display: grid;
    max-width: 600px;
    border: solid 1px var(--bg-grey);
  }
  center {
    margin-top: 4rem;
  }
  input {
    font-size: 1.2rem;
    margin: 0.5rem;
    padding: 0.5rem;
    border-radius: 0.5rem;
    border-color: var(--bg-grey);
    text-align: center;
  }
</style>
